import { render } from "./insurannce_prompt.vue?vue&type=template&id=579ca914&scoped=true"
import script from "./insurannce_prompt.vue?vue&type=script&lang=js"
export * from "./insurannce_prompt.vue?vue&type=script&lang=js"

import "./insurannce_prompt.vue?vue&type=style&index=0&id=579ca914&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579ca914"]])

export default __exports__